import React from "react";
import "./redButton.scss";

const RedButton = ({ text, onClick }) => {
    return (
        <div className="red-button unselectable" onClick={onClick}>
            {text}
        </div>
    );
};

export default RedButton;
